module.exports = __webpack_public_path__ + "img/template-02.097164b2.jpg";